import { forwardRef } from 'react'
import { useParams } from 'react-router-dom'
import { gql, useQuery } from '@apollo/client'

import { H1 } from 'js/components/Heading'
import { WidgetType } from 'js/page/Widget/types/WidgetType'

/**
 * Displays the title of a page as set in the page meta data.
 *
 * [^1]: The `guid` and `urlSlug` route parameters are used for the edit and view mode respectively.
 */
const PageTitle = forwardRef<HTMLHeadingElement, WidgetType>(
    ({ containerGuid }, ref) => {
        const urlParams = useParams(), // [^1]
            guid = containerGuid || urlParams.guid,
            urlSlug = urlParams.urlSlug

        const { data } = useQuery(
            PAGE_META_FOR_PAGE_TITLE_QUERY,
            guid
                ? { variables: { guid } }
                : urlSlug
                  ? { variables: { urlSlug } }
                  : { skip: true },
        )

        return (
            <H1 as="div" aria-hidden ref={ref}>
                {data?.entity?.title}
            </H1>
        )
    },
)

PageTitle.displayName = 'PageTitle'

const PAGE_META_FOR_PAGE_TITLE_QUERY = gql`
    query PageMetaForPageTitle($guid: String, $urlSlug: String) {
        entity(guid: $guid, urlSlug: $urlSlug) {
            guid
            ... on Page {
                title
            }
        }
    }
`

export default PageTitle
